import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';

const Products = () => {
    const base_url = process.env.REACT_APP_BASE_URL;
    const [products, setProducts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [sortOrder, setSortOrder] = useState('asc');
    const [deletePending, setDeletePending] = useState(false)
    const [addPending, setAddPending] = useState(false)
    const [productsPending, setProductsPending] = useState(false)
    const [totalProducts, setTotalProducts] = useState(0)

    const api = axios.create({
        baseURL: `${base_url}`
    });

    // Set the authorization token for all requests
    api.interceptors.request.use((config) => {
        // Add your authorization token logic here
        const token = sessionStorage.getItem('token');
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });

    const deleteProductSuccess = (msg) =>
        toast.success(msg, {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });
    const deleteProductError = (msg) =>
        toast.error(msg, {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });

    useEffect(() => {
        fetchData();
        api.get(`${base_url}/product/total-products/all`)
        .then(function (response) {
            console.log(response.data)
            setTotalProducts(response.data.result)
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response);
            } else {
                console.log("An error occurred")
            }
        })
    }, [currentPage]);

    const fetchData = async () => {
        setProductsPending(true)
        try {
            const response = await api.get(`${base_url}/product/product-by-page/10/${currentPage}`);
            setProducts(response.data.result);
            setProductsPending(false)
        } catch (error) {
            console.log(error);
        }
    };

    const handleDelete = (id) => {
        setDeletePending(true)
        api
            .post(`${base_url}/product/delete-product/${id}`)
            .then(function (response) {
                console.log(response.data);
                fetchData();
                setDeletePending(false)
                deleteProductSuccess("Product record was successfully deleted");
            })
            .catch(function (error) {
                console.log(error.response.data.message);
                deleteProductError("An error occurred while trying to fetch Product data")
            });
    };

    const toggleSortOrder = () => {
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(newSortOrder);
    };

    // Sort products array based on sortOrder
    const sortedProducts = sortOrder === 'asc' ? [...products] : [...products].reverse();

    // Pagination
    // const indexOfLastItem = currentPage * itemsPerPage;
    // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    // const currentItems = sortedProducts.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // modal content ==================================================================================================

    const [newProductId, setNewProductId] = useState("");
    const [newProductName, setNewProductName] = useState("");
    const [newProductDescription, setNewProductDescription] = useState("");

    const addProductSuccess = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });

    const handleAddProduct = (event) => {
        event.preventDefault();
        setAddPending(true);

        api.post(`${base_url}/product/add-product/`, {
            "product_id": newProductId,
            "product_name": newProductName,
            "description": newProductDescription
        })
            .then(function (response) {
                console.log(response.data);
                setNewProductId("");
                setNewProductName("");
                setNewProductDescription("");
                addProductSuccess("Product Entry was successfully added");
                fetchData();
                setAddPending(false);
            })
            .catch(function (error) {
                console.log(error);
            });
    };// Added by VM

    // navigation options
    const nextPage = () => {
        if (currentPage < Math.ceil(totalProducts / itemsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const firstPage = () => {
        setCurrentPage(1);
    };

    const lastPage = () => {
        setCurrentPage(Math.ceil(totalProducts / itemsPerPage));
    };

    const pageButtons = () => {
        const totalPages = Math.ceil(totalProducts / itemsPerPage);
        const buttons = [];

        // Display up to 3 page numbers ahead of the current page
        for (let i = currentPage; i <= currentPage + 2 && i <= totalPages; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`btn-pagination ${currentPage === i ? 'active-page' : ''}`}
                    onClick={() => setCurrentPage(i)}
                >
                    {i}
                </button>
            );
        }

        return buttons;
    };
    // end navigation options

    

    // =================================================================================================================

    return (
        <>
            <div>
                <div className="d-flex my-1">
                    <div className="pt-3">
                        <h5 className="section-title">
                            <i className="bi-tag"></i> PRODUCTS
                            <small className="text-secondary" style={{fontWeight:"400",fontSize:"smaller"}}> ({totalProducts})</small>
                        </h5>
                    </div>
                    <div className="flex-fill text-end">
                        <button
                            className="btn-custom"
                            data-bs-toggle="modal"
                            data-bs-target="#add-product"
                        >
                            <i className="bi bi-plus-circle"></i> Add
                        </button>
                        <button className="btn-custom ms-1" onClick={toggleSortOrder}>
                            {sortOrder === 'asc' ? <div><i className="bi bi-sort-down"></i> Sort</div> : <div><i className="bi bi-sort-up"></i> Sort</div>}
                        </button>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="table table-striped table-sm">
                        <thead className="table-dark">
                            <tr className="text-center">
                                <th>Product-ID</th>
                                <th>Product Name</th>
                                <th>Description</th>
                                <th>Created on</th>
                                <th>Manage</th>
                                <th className="text-center"><i className="bi-trash"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                productsPending ? (
                                    <tr>
                                        <td colSpan="5" className="text-center">
                                            <div className="spinner-border spinner-border-lg text-custom my-3"></div>
                                        </td>
                                    </tr>
                                ) : (
                                    products.map((item) => (
                                        <tr key={item.product_id}>
                                            <td>{item.product_id}</td>
                                            <td>{item.product_name}</td>
                                            <td style={{width:"50%"}}>{item.description}</td>
                                            <td>{moment(item.createdAt).format('DD MMM YYYY h:mm:ss a')}</td>
                                            <td>
                                                <button className="btn-custom-sm">
                                                    <i className="b"></i>Manage
                                                </button>
                                            </td>
                                            <td>
                                                <button className="btn-custom-sm" onClick={() => handleDelete(item.product_id)}>
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            </td>
                                            
                                        </tr>
                                    ))
                                )
                            }
                        </tbody>
                    </table>

                    {/* Added by VM */}
                <div className="pagination btn-group">
                    <button
                        className="btn-pagination"
                        onClick={firstPage}
                        disabled={currentPage === 1}
                    >
                        First
                    </button>

                    <button
                        className="btn-pagination"
                        onClick={prevPage}
                        disabled={currentPage === 1}
                    >
                        <i className="bi-chevron-left"></i>
                    </button>

                    {/* page numbered buttons */}
                    {pageButtons()}

                    <button
                        className="btn-pagination"
                        onClick={nextPage}
                        disabled={currentPage === Math.ceil(totalProducts / itemsPerPage)}
                    >
                        <i className="bi-chevron-right"></i>
                    </button>

                    <button
                        className="btn-pagination"
                        onClick={lastPage}
                        disabled={currentPage === Math.ceil(totalProducts / itemsPerPage)}
                    >
                        Last
                    </button>
                </div>
                </div>

                {/* Pagination */}
                {/* <div className="pagination">
                    {Array.from({ length: Math.ceil(sortedProducts.length / itemsPerPage) }, (_, index) => (
                        <button
                            key={index}
                            className={`${currentPage === index + 1 ? 'active-pagination-btn' : 'pagination-btn'}`}
                            onClick={() => paginate(index + 1)}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div> */}
            </div >

            {/* Modal data content */}
            <div className="modal fade" id="add-product">
                    <div className="modal-dialog modal-md">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h5 className="modal-title bold"><i className="bi bi-plus-circle"></i> Add Product</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>

                            {/* Modal Body */}
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <form onSubmit={handleAddProduct}>
                                        <div className="input-group my-3">
                                            <span className="input-group-text input-group-text-custom"><i className="bi bi-tag"></i></span>
                                            <input type="text" className="form-control custom-input-group" value={newProductId} onChange={(e) => setNewProductId(e.target.value)} placeholder="Product ID" required />
                                        </div>
                                        <div className="input-group my-3">
                                            <span className="input-group-text input-group-text-custom"><i className="bi bi-box"></i></span>
                                            <input type="text" className="form-control custom-input-group" value={newProductName} onChange={(e) => setNewProductName(e.target.value)} placeholder="Product Name" required />
                                        </div>
                                        <div className="input-group my-3">
                                            <span className="input-group-text input-group-text-custom"><i className="bi bi-card-text"></i></span>
                                            <input type="text" className="form-control custom-input-group" value={newProductDescription} onChange={(e) => setNewProductDescription(e.target.value)} placeholder="Description" required />
                                        </div>
                                        {
                                            addPending ? (
                                                <button type="submit" className="btn-custom w-100 disabled" disabled>
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                </button>
                                            ) : (
                                                <button type="submit" className="btn-custom w-100">Submit</button>
                                            )
                                        }
                                    </form>
                                </div>
                            </div>

                            {/* Modal Footer */}
                            <div className="modal-footer">
                                <button type="button" className="btn-gray-sm" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            {/* End modal data content */}
        </>
    );
};

export default Products;
